import React from 'react';
import withClickOutsideOnOverlay from '../../../../hoc/withClickOutsideOnOverlay';
import scanQrCodeImg from '../../../../assets/images/test_with_playground/scan-qr-button@2x.png';
import appStoreBadgeImg from '../../../../assets/images/test_with_playground/appstore@2x.png';
import googlePlayBadgeImg from '../../../../assets/images/test_with_playground/googleplay@2x.png';
import PopupWrapper from '../../../components/Popup/PopupWrapper';
import PopupHeader from '../../../components/Popup/PopupHeader';
import PopupBody from '../../../components/Popup/PopupBody';

class TestWithPlaugroundPopup extends React.Component {
    cancel = () => {
        this.props.onClose();
    }

    handleClickOutside = () => {
        this.cancel();
    }

    render() {
        return (
            <PopupWrapper className="test-with-plauground-popup">
                <PopupHeader title="Test Your Project With Alan Playground" onCancel={this.cancel} />
                <PopupBody>
                    <div className="test-with-plauground-popup_list">
                        <b>1.</b> Download Alan Playgound App by links below.<br />
                        <b>2.</b> Press the button <img src={scanQrCodeImg} className="test-with-plauground-popup_scan-qr-code-img" /> and scan the code.
                        </div>
                    <div className="test-with-plauground-popup_badges">
                        <a
                            target="_blank"
                            href="https://apps.apple.com/ca/app/alan-playground/id1474478921"
                            rel="noreferrer">
                            <img src={appStoreBadgeImg} className="test-with-plauground-popup_badge-img" />
                        </a>
                        <a
                            target="_blank"
                            href="https://play.google.com/store/apps/details?id=app.alan.playground"
                            rel="noreferrer">
                            <img src={googlePlayBadgeImg} className="test-with-plauground-popup_badge-img" />
                        </a>
                    </div>
                </PopupBody>
            </PopupWrapper>
        );
    }
}

export default withClickOutsideOnOverlay(TestWithPlaugroundPopup);